import { render, staticRenderFns } from "./ConfirmOwnershipChange.vue?vue&type=template&id=39f2d89a&scoped=true&"
import script from "./ConfirmOwnershipChange.vue?vue&type=script&lang=js&"
export * from "./ConfirmOwnershipChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2d89a",
  null
  
)

export default component.exports